import { Link } from "react-router-dom";
import { guEvents } from "@/mocks/events";

const formatHeat = (value: number) =>
  value >= 10000 ? `${(value / 10000).toFixed(1)}万` : `${value}`;

export default function HotTicker() {
  const items = guEvents.slice(0, 6);
  const loop = [...items, ...items];

  return (
    <div className="flex items-center gap-3 overflow-hidden border-b border-background-200 bg-foreground-950 py-2.5">
      <span className="ml-4 flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
        <i className="ri-flashlight-fill text-sm" />
        实时热搜
      </span>
      <div className="flex min-w-0 flex-1 overflow-hidden">
        <div className="gu-marquee flex shrink-0 items-center gap-8 whitespace-nowrap">
          {loop.map((item, index) => (
            <Link
              key={`${item.id}-${index}`}
              to={`/event/${item.id}`}
              className="flex shrink-0 cursor-pointer items-center gap-2 text-sm text-background-100 transition-colors hover:text-accent-300"
            >
              <span className="text-accent-400">#{index % items.length + 1}</span>
              <span className="max-w-[320px] overflow-hidden text-ellipsis">{item.title}</span>
              <span className="flex items-center gap-1 text-xs text-background-400">
                <i className="ri-fire-line" />
                {formatHeat(item.heat)}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}